/* tslint:disable */
import BackgroundImage from 'gatsby-background-image';
import styled from '@emotion/styled';
import React from 'react';

import { theme } from '@kindur/components';

const Container = styled(BackgroundImage)`
  height: 300px;
  ${theme.breakpoints.tabletDown} {
    height: 400px;
  }
`;
const Content = styled('div')`
  z-index: 1;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
`;
const Copy = styled('div')`
  text-align: center;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-shadow: 1px 1px #333;
  color: #fff;
  font-size: 1.1em;
  line-height: 1.5em;
  width: 70%;
  margin: 0;
`;

const StepContainer = styled('div')`
  a {
    font-family: 'Apercu Pro Regular', sans-serif;
    font-weight: 500;
    font-size: 1.25em;
    color: ${theme.colors.Turquoise60};
    :after {
      content: ' →';
    }
    ${theme.breakpoints.tabletDown} {
      width: 100%;
    }
  }
`;
const TitleContainer = styled('div')`
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-start;
  justify-content: center;
  align-items: center;
  margin: 0;
  height: 100%;
  width: 100%;
  background: ${theme.colors.Transparent.Black20};
`;
const Title = styled('h1')`
  font-family: 'SangBleu Sunrise Bold';
  font-size: ${theme.fontSizes.x2large};
  line-height: 56px;
  color: ${theme.colors.OffWhite};
  text-shadow: 1px 1px #333;
  text-align: center;
  width: 60%;
  ${theme.breakpoints.tabletDown} {
    width: 90%;
  }
`;

// @ts-ignore
const ImageHero = props => {
  return (
    <Container Tag="section" fluid={props.fluid}>
      <Content>
        <TitleContainer>
          <Title>{props.title}</Title>
        </TitleContainer>
        {props.children}
      </Content>
    </Container>
  );
};

const StyledImageHero = styled(ImageHero)`
  width: 100%;
  background-position: bottom center;
  background-repeat: repeat-y;
  background-size: cover;
`;

export default StyledImageHero;
